const validateBothImgSize = (imgW, imgH, refW, refH) => {
    return ((refW == imgW) && (refH == imgH)) || (imgW == refH) && (imgH == refW)
}

const validateImgSize = (imgW, imgH, refW, refH) => {
    return ((refW == imgW) && (refH == imgH))
}
export const ValidateImageArray = async (files, options = {}) => {
    try {
      console.log(`validatephoto`, files);
  
      if (!options) {
        throw new Error('Please specify validation options');
      }
  
      if (!options.imgtype || !Array.isArray(options.imgtype)) {
        console.log(`not found in array`);
        throw new Error('Please specify image types as an array');
      }
  
      const validFileList = [];
      const invalidFileList = [];
  
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileName = file.name;
        const fileExtension = fileName.replace(/^.*\./, '');
  
        if (options.imgtype.includes(fileExtension)) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
  
          await new Promise((resolve, reject) => {
            reader.onload = () => {
              const image = new Image();
              image.src = reader.result;
  
              image.onload = () => {
                const { width: W, height: H } = image;
                const refW = options.width;
                const refH = options.height;
  
                if (
                  options.validateType === 'both'
                    ? validateBothImgSize(W, H, refW, refH)
                    : validateImgSize(W, H, refW, refH)
                ) {
                  validFileList.push(file);
                } else {
                  invalidFileList.push({
                    file: file,
                    msg: `ขนาดไฟล์ไม่ถูกต้อง รองรับขนาด ${options.width} * ${options.height} px`,
                  });
                }
  
                resolve();
              };
  
              image.onerror = () => {
                reject(new Error(`Failed to load image ${file.name}`));
              };
            };
  
            reader.onerror = () => {
              reject(new Error(`Failed to read file ${file.name}`));
            };
          });
        } else {
          invalidFileList.push({
            file: file,
            msg: `รองรับเฉพาะไฟล์ PNG , JPG , JPEG เท่านั้น`,
          });
        }
      }
  
      console.log('validFileList', validFileList);
      console.log('invalidFileList', invalidFileList);
  
      return {
        successFiles: validFileList,
        failFiles: invalidFileList,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  

export const ValidateImage = (file, options={})=>{
    return new Promise((resolve, reject) => {

        console.log(`validatephoto`, file)
        if(!options) reject('please  specify validate options')

        if(!'imgtype' in options || !Array.isArray(options.imgtype)) {
            console.log(`not found in array`)
            reject('please specify image type')
        }

        if(file) {
            const fileName = file.name        
            const fileExtension = fileName.replace(/^.*\./, '');

            if (options.imgtype.includes(fileExtension)) {
                const reader = new FileReader()
                reader.readAsDataURL(file);
                reader.onload = function (fe) {
                    const image = new Image()
                    image.src = fe.target.result;
                    image.onload = function(){
                        const H = this.height
                        const W = this.width
                        const refW = options.width
                        const refH = options.height

                        if('validateType' in options && options.validateType == 'both') {
                            
                            if(validateBothImgSize(W, H, refW, refH)) {
                                resolve(file)
                            }else{
                                reject(`ขนาดไฟล์ไม่ถูกต้อง รองรับขนาด ${options.width} * ${options.height} px หรือ ${options.height} * ${options.width}`)
                            }
                        }else{
                            if(validateImgSize(W, H, refW, refH)) {
                                resolve(file)
                            }else{
                                reject(`ขนาดไฟล์ไม่ถูกต้อง รองรับขนาด ${options.width} * ${options.height} px`)
                            }
                        }
                    }
                }
            }else{
                reject("รองรับเฉพาะไฟล์ PNG , JPG , JPEG เท่านั้น")
            }
        }
        
    })
}
export const ValidateImageMatchSize = (file, options={})=>{
    return new Promise((resolve, reject) => {

        console.log(`validatephoto`, file)
        if(!options) reject('please  specify validate options')

        if(file) {
            const fileName = file.name        
            const fileExtension = fileName.replace(/^.*\./, '');
            if (fileExtension == 'png' || fileExtension == 'jpg' || fileExtension == 'jpeg') {
                const reader = new FileReader()
                reader.readAsDataURL(file);
                reader.onload = function (fe) {
                    const image = new Image()
                    image.src = fe.target.result;
                    image.onload = function(){
                        const H = this.height
                        const W = this.width
                        // H !== 640 || W !== 640
                        if(H == options.height && W == options.width){
                            console.log("VAL CORRECT PHOTO")
                            resolve()
                        }else{
                            console.log("VAL INCORRECT PHOTO", file)
                            reject(`ขนาดไฟล์ไม่ถูกต้อง รองรับขนาด ${options.width} * ${options.height} px`)
                        }
                    }
                }
            }else{
                reject("รองรับเฉพาะไฟล์ PNG , JPG , JPEG เท่านั้น")
            }
        }
        
    })
}

export const ValidatePngMatchSize = (file, options={})=>{
    return new Promise((resolve, reject) => {

        console.log(`validatephoto`, file)
        if(!options) reject('please validate image option specify options')

        if(file) {
            const fileName = file.name        
            const fileExtension = fileName.replace(/^.*\./, '');
            if (fileExtension == 'png') {
                const reader = new FileReader()
                reader.readAsDataURL(file);
                reader.onload = function (fe) {
                    const image = new Image()
                    image.src = fe.target.result;
                    image.onload = function(){
                        const H = this.height
                        const W = this.width
                        // H !== 640 || W !== 640
                        if(H == options.height && W == options.width){
                            console.log("VAL CORRECT PHOTO")
                            resolve()
                        }else{
                            console.log("VAL INCORRECT PHOTO", file)
                            reject(`ขนาดไฟล์ไม่ถูกต้อง รองรับขนาด ${options.width} * ${options.height} px`)
                        }
                    }
                }
            }else{
                reject("รองรับเฉพาะไฟล์ PNG  เท่านั้น")
            }
        }
        
    })
}
